import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

const PATH_TEMPLATE = '/creators/{creatorId}/custom-terms-dynamic-variables/{id}';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['DELETE'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const deleteTypedDynamicVariable = async ({ creatorId, id }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, {creatorId, id});
  const data = await noodleApiClient.delete(path);
  return data.data;
};

export default deleteTypedDynamicVariable;